import { createContext, useEffect, useState } from 'react';
import { Bank, BanksResponse, BankResponse, CountriesResponse, Country, ProvinceResponse, CantonResponse, DistrictResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';

/*
router.get('/getProvincesExternal/:country_id', controller.getProvincesExternal);
    router.get('/getCantonsExternal/:country_id/:province_id', controller.getCantonsExternal);
    router.get('/getDistrictsExternal/:country_id/:province_id/:canton_id', controller.getDistrictsExternal);
*/


type RegisterContextProps = {
    isLoading: boolean;
    loadProvinces: () => Promise<ProvinceResponse>;
    loadCantons: (province: number) => Promise<CantonResponse>;
    loadDistricts: (province: number, canton: number) => Promise<DistrictResponse>;
    save: (request: any) => Promise<string>;

}



export const RegisterContext = createContext({} as RegisterContextProps);

export const RegisterProvider = ({ children }: any) => {


    const [isLoading, setIsLoading] = useState(false);

    const loadProvinces = async () => {
        let response = null;
        const resp = await topApi.get<ProvinceResponse>('/location/getProvincesExternal/1');
        if (resp.status == 200) {
            response = resp.data;
        }
        return response;
    }

    const loadCantons = async (province: number) => {
        let response = null;
        const resp = await topApi.get<CantonResponse>(`/location/getCantonsExternal/1/${province}`);
        if (resp.status == 200) {
            response = resp.data;
        }
        return response;
    }

    const loadDistricts = async (province: number, canton: number) => {
        let response = null;
        const resp = await topApi.get<DistrictResponse>(`/location/getDistrictsExternal/1/${province}/${canton}`);
        if (resp.status == 200) {
            response = resp.data;
        }
        return response;
    }

    const save = async (request: any) => {
        let isSuccess = false;
        let message = '';
        setIsLoading(true);

        const resp = await topApi.post(`/affiliation/register`, request, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        if (resp.status == 200) {
            isSuccess = resp.data.isSuccess;
            message = resp.data.message;
        }
        setIsLoading(false);
        return isSuccess ? 'success' : message;
    }


    return (
        <RegisterContext.Provider value={{ loadProvinces, loadCantons, loadDistricts, isLoading, save }}>
            {children}
        </RegisterContext.Provider>
    );
}